/* eslint new-cap: ["error", { "capIsNewExceptions": ["Intercom"] }]*/
/* global Intercom */

'use strict';

import $ from 'jquery';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).ready(function () {
    $(document).on('click', '.radio--invite-clients', function () {
      const kind = $(this).data().kind;
      $('.invite-clients-block__links').addClass('hide');
      $(`.invite-clients-block__links--${kind}`).removeClass('hide');

      return true;
    });

    $(document).on('change', '.field--invite-clients-questionnaire', (e) => {
      $('.field--questionnaire-team-url').val($(e.target).val());
      const $selectedEl = $(e.target).find(':selected');
      const $container = $(e.target).parents('.invite-clients-block__links');
      $container
        .find('.invite-clients-block__link--preview')
        .attr('href', $selectedEl.data('preview'));
      $container
        .find('.invite-clients-block__link--facebook')
        .attr('href', $selectedEl.data('facebook'));
      $container
        .find('.invite-clients-block__link--twitter')
        .attr('href', $selectedEl.data('twitter'));
      $container.find('.invite-clients-block__link--email').attr('href', $selectedEl.data('email'));
      $container
        .find('.invite-clients-block__link--widget')
        .attr('href', $selectedEl.data('widget'));
    });

    const $bookmarkletTagsField = $('.field--bookmarklet-tags');
    if ($bookmarkletTagsField && typeof $bookmarkletTagsField.selectize === 'function') {
      const initTags = $bookmarkletTagsField.data('tags');
      let tags = initTags;
      if ($bookmarkletTagsField.val()) {
        const currentTags = $bookmarkletTagsField
          .val()
          .split(',')
          .map((tag) => {
            return { data: tag, value: tag };
          });
        tags = currentTags.concat(initTags);
      }
      const bookmarkletUuid = $bookmarkletTagsField.data('uuid');

      $bookmarkletTagsField.selectize({
        plugins: ['remove_button'],
        persist: false,
        createOnBlur: true,
        create: true,
        sortField: {
          field: 'text',
          direction: 'asc',
        },
        options: tags,
        render: {
          item(data, escape) {
            return `<div class="field__tag-item">${escape(data.text)}</div>`;
          },
        },
        load: (query, callback) => {
          if (!query.length) {
            return callback();
          }
          $.ajax({
            url: '/bookmarklet/xhr_selectize_tags',
            type: 'GET',
            data: { q: query, uuid: bookmarkletUuid },
            error: () => {
              callback();
            },
            success: (res) => {
              callback(res);
            },
          });
        },
      });
    }

    $(document).on(
      'click',
      '.dropdown-menu__link--copy-shareable-link, .h-s-button--copy-shareable-link',
      function (e) {
        e.preventDefault();
        const shareableLink = $(e.currentTarget).data('shareable-link');

        navigator.clipboard.writeText(shareableLink).catch((err) => {
          console.error('Unable to copy link. Please try again.');
        });
      }
    );
  });

  $(document).ready(function () {
    if (location.hash === '#modal--invite-clients') {
      $('.modal--invite-clients').modal();
    }
    if ($('#shareables-project-design').length) {
      // Disable root link in breadcrumps trail for instant access links
      const projectName = $('.page-header--project-name').text().trim();
      $('.page-header--project-name').text(projectName);
    }
  });

  $(document).on('click', '.contact-us-intercom', (event) => {
    const newChat = event.target.classList.contains('contact-us-intercom--new-chat');

    if (typeof Intercom !== 'undefined') {
      newChat ? Intercom('showNewMessage') : Intercom('show');
    }
    return false;
  });

  $(document).on('click', '.message-band__read-more', (e) => {
    $(e.target).siblings('.message-band__more').show();
    $(e.target).hide();
  });

  $(document).on('click', '.message-band__show-less', (e) => {
    $(e.target).parents('.message-band__more').hide();
    $(e.target).parents('.message-band').find('.message-band__read-more').show();
  });

  if (document.querySelector('#modal--login')) {
    $(document).on('click', '.login-required', (e) => {
      e.preventDefault();
      $('.modal--login').modal();
    });
  }

  // The login modal reuses the shared client-login partial, whose link/password
  // swap is handled by the client-login Stimulus controller. Reset it to the
  // instant-access-link view each time the modal opens.
  $(document).on($.modal.OPEN, '.modal--login', () => {
    const linkForm = document.querySelector('.modal--login [data-client-login-target="linkForm"]');
    const passwordForm = document.querySelector(
      '.modal--login [data-client-login-target="passwordForm"]'
    );
    if (linkForm && passwordForm) {
      linkForm.classList.remove('hide');
      passwordForm.classList.add('hide');
    }
  });

  $(document).ready(function () {
    // when client switched team, we need to "force reload" other opening tabs to reload the correct current team
    // to achieve this, we listen to event of local storage changes and fire the event by controller's system flash
    function storageChange(event) {
      if (event.key === 'df_client_switched_team') {
        location.reload();
      }
    }
    window.addEventListener('storage', storageChange, false);

    if ($('body').data('system-flash') === 'df_client_switched_team') {
      window.localStorage.setItem('df_client_switched_team', Math.random());
    }
  });

  $(document).on('click', '.project-details__print-link', () => {
    window.print();
    return false;
  });
});
